import axios from "axios";
import { 
  GET_LICENSES_VOLUMETRIC_INV,
  GET_VOLUMETRIC_INV,
  CLEAR_VOLUMETRIC_INV,
  CHANGE_CRE_LICENSE_VOLUMETRIC_INV,
  SELECT_VOLUMETRIC_INV,
  VOLUMETRIC_INV_INPUTS_FILTERS,
} from "redux/reducers/volumetricsInventory/volumetricInvReducer";
import { START_REQUEST_SEARCH, STOP_REQUEST_SEARCH, SET_SNACKBAR_SEARCH } from "redux/reducers/search/searchReducer";
import { formatCustomDate } from "helpers/dateTools";

export const getCRE_Licenses = ( token ) => {
  const url = `${process.env.REACT_APP_URL}/crm/stations/cre_licenses`
  const headers = { headers: { Authorization: token } }
  let payload = {}
  return async( dispatch ) => {
    await axios.get(url, headers).then(resp => {
      payload = {
        type: GET_LICENSES_VOLUMETRIC_INV,
        payload: resp.data
      }
      dispatch(payload)
    }).catch(error => {
      const err = error.response.data?.message.error
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: { message: err ? err : "Error contacte con el administrador", color: 'danger' }
      })
    })
  }
}

export const getVolmetricsInv = ( token, licence, start, end ) => {
  const paramsString = `&start=${start}&end=${end}&licence=${licence}`
  const options = {
    method: 'GET',
    url: `${process.env.REACT_APP_URL_VOL}/volumetrics?qid=WzJtDATMlVnft8cB${paramsString}`,
    headers: { Authorization: token },
  }
  let payload = {}
  return async ( dispatch ) => {
    dispatch({ type: START_REQUEST_SEARCH })

    await axios.request(options).then(resp => {
      payload = {
        type: GET_VOLUMETRIC_INV,
        payload: resp.data.map(info => ({...info, dateFormated: formatCustomDate(info.date, '-')}))
      }
      dispatch(payload)
    }).catch(error => {
      const err = error?.response?.data?.message?.error
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: { message: err ? err : "Error contacte con el administrador", color: 'danger' }
      })
    })
    dispatch({ type: STOP_REQUEST_SEARCH })
  }
}

export const changeCreLicenseVolmetricsInv = ( license ) => {
  return {
    type: CHANGE_CRE_LICENSE_VOLUMETRIC_INV,
    payload: license,
  };
}

export const selectVolumetricInv = ( volumetric ) => {
  return {
    type: SELECT_VOLUMETRIC_INV,
    payload: volumetric,
  };
}

export const clearVolumetricsInv = () => {
  return {
    type: CLEAR_VOLUMETRIC_INV,
  }
}


export const volumetricInvSearchInputs = (key = '', value) => {
  return {
    type: VOLUMETRIC_INV_INPUTS_FILTERS,
    payload: { key, value }
  }
}
